export default __webpack_public_path__ + "static/media/4C.3ebe0e73.svg";